import { defineMessages } from 'react-intl';

export default defineMessages({
  buttonText: {
    id: 'app.user.containers.FacebookLogin.buttonText',
    defaultMessage: 'Continuar con Facebook',
  },
});
